<template>
  <li class="itemNotice-li">
    <router-link :to="'/paperArticle/'+articleId+'/'+tabName" class="itemNotice-a">{{title}}</router-link>
    <span class="itemNotice-span">{{create_time}}</span>
    <hr>
  </li>
</template>
<script>
import '../../../node_modules/bootstrap/dist/js/bootstrap.js'

export default {
  name: 'character',
  props: ['title', 'create_time', 'articleId', 'tabName'],
  data () {
    return {
    }
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import '../joinprocess/main.css';
  .itemNotice-li{
    margin-left: -20px;
    margin-right: 20px
  }
  .itemNotice-a{}
  .itemNotice-span{
    float: right
  }
</style>



// WEBPACK FOOTER //
// src/components/item/itemPaper.vue